import { classSet } from '@platform/ui-library';

type LoadingSpinnerProps = {
  message?: string | JSX.Element;
  hideSpinner?: boolean;
  className?: string;
};

const LoadingSpinner = ({ message = 'Downloading Content...', hideSpinner, className }: LoadingSpinnerProps) => {
  const classNames = classSet(['loading-spinner', className]);
  return (
    <div className={classNames}>
      <div className="spinner" style={{ userSelect: 'none' }}>
        <span
          style={{ padding: '7px', display: hideSpinner ? 'none' : 'inline-block' }}
          className="glyphicon glyphicon-refresh glyphicon-refresh-animate"
        ></span>
        {message}
        <a href="#"></a>
      </div>
    </div>
  );
};

export default LoadingSpinner;
